// extracted by mini-css-extract-plugin
export default {"main":"ListUsers_main__BZANh","section":"ListUsers_section__ke9mw","sectionOne":"ListUsers_sectionOne__PZQMN","contButtons":"ListUsers_contButtons__icM6h"};